<template>
  <v-stepper 
  v-if="$store.state.producto!=0"
  v-model="e6" vertical>
    <v-stepper-step :complete="e6 > 1" step="1">
      Resumen de Compra
      <small>Total a pagar = S/.{{round($store.state.totalventa)}}</small>
    </v-stepper-step>

    <v-stepper-content step="1">
      <v-card class="mb-6" height="120px">
            <v-list-item three-line>
            <v-list-item-content>
            <v-list-item-subtitle class="headline mt-n3 pa-3">
              <h5 class="red--text body-1">
                <strong class="black--text">Total a pagar = </strong>  S/.{{round($store.state.totalventa)}}</h5>
              </v-list-item-subtitle>
            <v-list-item-subtitle class="headline mt-n3 pa-3">
              <h5 class="red--text body-1"> <strong class="black--text">Productos = </strong>{{$store.state.totalproducto}} und.</h5>
              </v-list-item-subtitle>
            </v-list-item-content>
            </v-list-item>
      </v-card>
      <v-btn color="primary" :disabled="boton1" @click="e6 = 2">Continuar</v-btn>
    </v-stepper-content>

    <v-stepper-step :complete="e6 > 2" step="2">Informacion Cliente</v-stepper-step>

    <v-stepper-content step="2">
                  <v-btn block class="green mb-3 white--text" min-width="175"
            @click.stop="$store.commit('abrirdialogocliente')">
            Soy Nuevo cliente</v-btn>
            
            <v-btn block class="green mb-3 white--text" min-width="175"
            @click.stop="$store.commit('dialogobuscaCliente')">
            Ya estoy registrado</v-btn>

                <v-card 
                class="mt-3 mb-3"
                outlined 
                 v-for="cli in $store.state.cliente"
                  :key="cli" >
                <v-list-item-content>
                    <v-list-item-title class="headline mt-n3 pa-3"><h5>Cliente:</h5></v-list-item-title>
                     <v-divider class=" mt-n6"></v-divider>
                    <v-list-item-subtitle class="headline mt-n3 pa-3">
                      <h6 class="caption"><strong>Dni: </strong>{{cli.dni}}</h6></v-list-item-subtitle>
                    <v-list-item-subtitle class="headline mt-n3 pa-3">
                      <h6 class="caption"><strong>Nombre: </strong>{{cli.nombreCompleto}}</h6></v-list-item-subtitle>
                      <v-list-item-subtitle class="headline mt-n3 pa-3">
                      <h6 class="caption"><strong>Nombre: </strong>{{cli.celular}}</h6></v-list-item-subtitle>
                </v-list-item-content>
                <v-card-actions>
                      <v-btn class="mt-n9" color="primary"  @click="e6 = 3">Continuar</v-btn>
                </v-card-actions>
                </v-card>


      <v-btn color="error" text @click="e6 = 1">Regresar</v-btn>
    </v-stepper-content>

    <v-stepper-step :complete="e6 > 3" step="3">Direccion de Envio</v-stepper-step>

    <v-stepper-content step="3">

                    <v-btn block class="error mb-3" min-width="175"  
                    @click.stop="$store.commit('abrirdialogodireccion')">
                    Agrega Direccion</v-btn>

                <v-card 
                class="mt-3"
                outlined 
                 v-for="direc in $store.state.direc"
                  :key="direc" >
                <v-list-item-content>
                    <v-list-item-subtitle class="headline mt-n3 pa-3">
                      <h6 class="caption"><strong>Zona: </strong>{{direc.departamento}} - {{direc.provincia}}</h6></v-list-item-subtitle>
                      <v-list-item-subtitle class="headline mt-n3 pa-3">
                      <h6 class="caption"><strong>Distrito: </strong>{{direc.distrito}}</h6></v-list-item-subtitle>
                      <v-list-item-subtitle class="headline mt-n3 pa-3">
                      <h6 class="caption"><strong>Direccion: </strong>{{direc.direccion}}</h6></v-list-item-subtitle>
                      <v-list-item-subtitle class="headline mt-n3 pa-3">
                      <h6 class="caption"><strong>Referencia: </strong>{{direc.referencia}}</h6></v-list-item-subtitle>
                </v-list-item-content>
                <v-card-actions>
                        <v-btn  class="mt-n9" color="primary" @click="e6 = 4">Continuar</v-btn>
                </v-card-actions>
                  </v-card>
    

      <v-btn color="error" text @click="e6 = 2">Regresar</v-btn>
    </v-stepper-content>

    <v-stepper-step step="4">Metodo de Pago</v-stepper-step>
    <v-stepper-content step="4">
      
              <pasarelaPago/>

      <v-btn text color="error" @click="e6 = 3">Regresar</v-btn>
    </v-stepper-content>
  <dialogobuscaCliente/>

  </v-stepper>
</template>
<script>
import { db } from '../db'
import store from '@/store/index'
import dialogobuscaCliente from '@/components/dialogobuscaCliente'
import pasarelaPago from '@/components/pasarelaPago'

  export default {
      name: 'pasosConfirmaVenta',

      components: {
        dialogobuscaCliente,
        pasarelaPago
        },

    data () {
      return {
        disabled:false,
        e6: 1,
      }
    },
    methods:{

          round(num, decimales = 2) {
              var signo = (num >= 0 ? 1 : -1);
              num = num * signo;
              if (decimales === 0) //con 0 decimales
                  return signo * Math.round(num);
              // round(x * 10 ^ decimales)
              num = num.toString().split('e');
              num = Math.round(+(num[0] + 'e' + (num[1] ? (+num[1] + decimales) : decimales)));
              // x * 10 ^ (-decimales)
              num = num.toString().split('e');
              return signo * (num[0] + 'e' + (num[1] ? (+num[1] - decimales) : -decimales));
          },
         
      }
  }
</script>